<template>
  <!-- ======= Footer ======= -->
  <footer id="footer">
    <div class="container">
      <h3>José Santiago</h3>
      <p>
        Si tu negocio no está en Internet, tu negocio no existe.
        <strong>Bill Gates</strong> (informático)
      </p>

      <div class="social-links">
        <!--a href="https://twitter.com/uncaiman_"  target="_blank" class="twitter"><i class="bx bxl-twitter"></i></a-->
        <a href="https://www.facebook.com/JoseSantiago1312" target="_blank" class="facebook"><i class="bx bxl-facebook"></i></a>
        <!--a href="https://www.instagram.com/uncaiman_" target="_blank" class="instagram"><i class="bx bxl-instagram"></i></a-->
      </div>
      <div class="copyright">
        <strong><span>JoséSantiago</span></strong>.
      </div>
      <div class="credits">
        <!-- All the links in the footer should remain intact. -->
        <!-- You can delete the links only if you purchased the pro version. -->
        <!-- Licensing information: [license-url] -->
        <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/free-html-bootstrap-template-my-resume/ -->
       <!-- Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>-->
      </div>
    </div>
  </footer>
  <!-- End Footer -->

</template>

<script>
export default {
name: "FooterComponent"
}
</script>

<style scoped>

</style>